import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import theme from '../../constants/theme'
import {
  NoWrapText,
  ProgressBarWrap,
  ProgressTrack,
  ProgressFill,
} from './styles'

function ProgressBar({ answeredCount, total }) {
  const { t } = useTranslation()
  const pct = total ? Math.round((answeredCount / total) * 100) : 0

  return (
    <ProgressBarWrap className="mb-4">
      <NoWrapText size="13px" color={theme.talentinoTextGray}>
        {answeredCount} {t('assessment.of')} {total} {t('assessment.answered')}
      </NoWrapText>
      <ProgressTrack>
        <ProgressFill pct={pct} />
      </ProgressTrack>
      <NoWrapText bold size="12px" color={theme.brandColorOrange}>
        {pct}%
      </NoWrapText>
    </ProgressBarWrap>
  )
}

ProgressBar.propTypes = {
  answeredCount: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
}

export default ProgressBar
